import {  get, publicPost,post, put, deleteRequest } from "../../helpers/apihelpers";

export const DigitalCardDistributorLogInService = async (data)=>{
    try {
      const result = await publicPost(`api/digital_card_distributors/login`, data);
      return result;
    } catch (err) {
      return err.response;
    }
}

export const CreateDigitalCardDistributorService=async(data)=>{
    try {
        const result = await publicPost(`api/digital_card_distributors/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetDigitalCardDistributorSearchService = async (search,page)=>{
  try {
    const result = await get(`api/digital_card_distributors/search?search=${search}&page=${page}`);
    return result;
  } catch (err) {
    return err.response;
  }
}

export const UpdateDigitalCardDistributorPasswordService = async (data,id)=>{
  try {
    const result = await post(`api/digital_card_distributors/change-password-admin`, data);
    return result;
  } catch (err) {
    return err.response;
  }
}


export const UpdateDigitalCardDistributorPassword1Service = async (data,id)=>{
  try {
    const result = await put(`api/digital_card_distributors/change-password`, data);
    return result;
  } catch (err) {
    return err.response;
  }
}

export const UpdateDigitalCardDistributorService=async(data,id)=>{
    try {
        const result = await post(`api/digital_card_distributors/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteDigitalCardDistributorService=async(id)=>{
    try {
        const result = await deleteRequest(`api/digital_card_distributors/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetDigitalCardDistributorDetailService=async(id)=>{
    try {
        const result = await get(`api/digital_card_distributors/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetDigitalCardDistributorListService=async(page)=>{
    try {
        const result = await get(`api/digital_card_distributors/get/${page}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateDigitalCardDistributorRoleService = async (data) => {
    try {
        const result = await put(`api/digital_card_distributors/assign-user-roles`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const getMyDigitalCardDistributorProfile = async (id) =>{
  try {
    const result = await get(`api/digital_card_distributors/profile/${id}`);
    return result;
  } catch (err) {
    return err.response;
  }
}
